// extracted by mini-css-extract-plugin
export default {"title":"OrganizationsIndexPage_title__cyvz6","header":"OrganizationsIndexPage_header__DzItQ","button":"OrganizationsIndexPage_button__A7p6a"};